import React, { Component, Fragment } from 'react';
import HomeContent from "../HomeContent/HomeContent";

class InquiryStaticPage extends Component {
    componentDidMount() {
        setTimeout(()=>{
            document.getElementById('sub-title-span-resp').click();
        },1000)
    }

    render() {
        return(
            <Fragment>
                <HomeContent/>
            </Fragment>
        );
    }
}
export default InquiryStaticPage;


// WEBPACK FOOTER //
// ./src/components/Site/UserInquiry/InquiryStaticPage.js